import React from 'react';
import "./scrollbar.scss"
export default class ScrollBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            scrollX: 0,
            maxRange: 0,
            moveStart: false,
            floatUnit: this.props.floatUnit || 0,
            id: this.random(10)
        }
        this.moveStart = false;
    }
    componentDidMount() {
        this.init();
    }
    random(len) {
        len = len || 10;
        let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
        let maxPos = chars.length;
        let randomString = "";
        for (let i = 0; i < len; i++) {
            randomString += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return randomString;
    }
    init() {
        let client = document.getElementById(`scroll_bar${this.state.id}`).getBoundingClientRect();
        let circleW = document.getElementById(`scroll_circle${this.state.id}`).offsetWidth;
        this.setState({
            maxRange: client.width - circleW,
            minRange: client.left

        })

    }
    reInit() {
        this.setState({
            scrollX: 0
        }, () => {
            this.countScrollNum()
        })
    }
    mouseDown(e) {
        this.moveStart = true;
        window.addEventListener("mouseup", () => {
            this.mouseUp();
        })
        window.addEventListener("mousemove", (e) => {
            this.mouseMove(e);
        })
    }
    mouseMove(e) {
        if (!this.moveStart) {
            return false;
        }
        let x = e.clientX - this.state.minRange;
        if (x >= this.state.maxRange) {
            x = this.state.maxRange;
        }
        else if (x < 0) {
            x = 0
        }
        this.setState({
            scrollX: x
        }, () => {
            this.countScrollNum()
        })
    }
    countScrollNum() {
        let percent = 0;
        let scrollX = this.state.scrollX
        let Scale = (this.props.maxnum - this.props.minnum) / 100
        if (scrollX == 0) {
            percent = this.props.minnum
        }
        else if (scrollX == this.state.maxRange) {
            percent = this.props.maxnum
        }
        else {
            percent = scrollX / this.state.maxRange * 100;
            percent = Scale * percent
            if (this.state.floatUnit > 0) {
                percent = (this.props.minnum + percent).toFixed(this.state.floatUnit + 1);
                percent = percent.substring(0, percent.length - 1);
                percent = parseFloat(percent);
            }
            else {
                percent = parseInt(percent);
                percent = this.props.minnum + percent
            }


        }
        this.props.callBack && this.props.callBack(percent);
    }
    mouseUp() {
        this.moveStart = false;
    }
    render() {
        return (
            <div className="scroll_bar_view" id={`scroll_bar${this.state.id}`}>
                <div className="scroll_bar_bg" >
                </div>
                <div className="scroll_bar_circle" id={`scroll_circle${this.state.id}`} style={{ left: this.state.scrollX }} onMouseDown={(e) => { this.mouseDown(e) }} onMouseMove={(e) => { this.mouseMove(e) }} onMouseUp={() => {
                    this.mouseUp()
                }} ></div>
            </div>
        )
    }
}